import { ChangeEvent } from 'react';
import Alert from 'components/Alert';
import isAlphanumeric from 'utils/isAlphanumeric';
import { OnboardingSlideProps } from 'models';
import { StyledBox, StyledTextField } from './ReferAFriend.styles';

const ReferAFriend = ({
  onboardingData: { referralCode, referralCodeError, buttonState },
  setOnboardingData,
}: OnboardingSlideProps) => {
  const validateReferralCode = (code: string) => {
    const isValidCode = isAlphanumeric(code);

    setOnboardingData({
      type: 'setReferralCodeError',
      data: { referralCodeError: isValidCode ? null : { type: 'alphanumeric' } },
    });

    return isValidCode;
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedReferralCode = event.target.value;
    const updatedButtonState = {
      ...buttonState,
      referAFriend: !validateReferralCode(updatedReferralCode),
    };

    setOnboardingData({
      type: 'setButtonState',
      data: { buttonState: updatedButtonState },
    });

    setOnboardingData({
      type: 'setReferralCode',
      data: { referralCode: updatedReferralCode },
    });
  };

  return (
    <StyledBox>
      <StyledTextField
        onChange={handleOnChange}
        fullWidth
        value={referralCode}
        placeholder="Referral code (optional)"
        label="Enter your referral code"
        variant="filled"
        InputLabelProps={{ shrink: true }}
      />
      {referralCodeError && <Alert text={referralCodeError.text} type="error" />}
    </StyledBox>
  );
};

export default ReferAFriend;
